import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MensagemMural } from '../persistences/mensagem-mural';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MuralService {
  private mensagensNaoLidasSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  constructor(
    private configService: ConfigService,
    private httpClient: HttpClient,
  ) { }

  getMensagensNaoLidasObservable(): Observable<number> {
    return this.mensagensNaoLidasSubject.asObservable();
  }

  setMensagensNaoLidas(count: number): void {
    this.mensagensNaoLidasSubject.next(count);
  }

  getMensagensMural(){
    return this.httpClient.get<MensagemMural[]>(
      this.configService.getEndereco() + "/Business/Mural/getMensagensMural",
      {
        headers: this.configService.getHeaders()
      }
    )
  }

  atualizaMensagemLida(idMensagem: string){
		let httpParams = new HttpParams();
		httpParams = httpParams
			.append('idMensagem', idMensagem);
    return this.httpClient.post(
      this.configService.getEndereco() + "/Business/Mural/atualizaByIdMensagem",
        idMensagem,
      {
        headers: this.configService.getHeaders(),
      }
    ).pipe(
      tap(() => {
        this.getMensagensMural().subscribe((mensagens) => {
          this.getMensagensNaoLidas(mensagens);
        });
      })
    );
  }

  getMensagensNaoLidas(mensagensMural: MensagemMural[]){
		this.setMensagensNaoLidas(mensagensMural.filter((mensagem)=> { return !mensagem.dt_hr_leitura}).length);
	}
}
